import { Card } from "@120wateraudit/waterworks";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import Page from "src/components/Page";
import { SubmissionPeriodDropdown } from "src/modules/Submissions/SubmissionPeriodDropdown";
import styled from "styled-components";
import PageHeader from "src/components/PageHeader";
import Loader from "src/components/Loader";
import Exporter from "./Exporter";
import { useConfig, Flags } from "src/hooks/useConfig";
import { useTableState } from "src/hooks/useTableState";
import { useIsWrite } from "src/modules/User";
import { SubnavigationTabs } from "src/components/SubnavigationTabs/SubnavigationTabs";
import SubmissionsStatusesMetricsCard from "./SubimssionsStatusesMetricsCard";
import { CustomerNoticeCertificationsTable } from "src/modules/Submissions/CustomerNoticeCertificationsTable";
import { SubmissionPeriodType } from "src/types/enums/SubmissionPeriodType";
import { ExportType } from "src/types/enums/ExportRequest";
import PrimaryButton from "src/components/PrimaryButton";

const CustomerNoticeCertificationPage: React.FC = () => {
  const { isWrite } = useIsWrite();
  const [submissionPeriodId, setSubmissionPeriodId] = React.useState<number>();

  const [statePortalSubmissionsExportEnabled] = useConfig(
    Flags.statePortalSubmissionsExport
  );

  const exportOptions = useMemo(() => [
    ...(statePortalSubmissionsExportEnabled
      ? [
          {
            key: "exportSubmissionPeriod",
            text: "Submissions",
            value: ExportType.PWSSubmissionPeriod,
          },
        ]
      : []),
  ], [statePortalSubmissionsExportEnabled]);

  const navigate = useNavigate();

  const handleClick = (): void => {
    navigate("/accountSettings/manageSubmissionPeriods");
  };

  const tableContext = useTableState();

  return (
    <Page
      title={
        <TitleContainer>
          <PageHeader>Customer Notice Certifications Submissions</PageHeader>

          {isWrite && (
            <PrimaryButton variant="primary" onClick={handleClick}>
              Create a New Submission Period
            </PrimaryButton>
          )}
        </TitleContainer>
      }
    >
      <SubnavigationTabs
        subnavigationTabs={[
          { label: "Inventory", to: "/submissions" },
          {
            label: "Customer Notice Certifications",
            to: "/submissions/customerNoticeCertification",
          },
        ]}
      />
      <TopSectionWrapper>
        <SubmissionsStatusesMetricsCard
          submissionPeriodId={submissionPeriodId}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "-webkit-fill-available",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <SubmissionPeriodDropdown
            setSubmissionPeriodId={setSubmissionPeriodId}
            defaultFilters={{
              submissionType: SubmissionPeriodType.customerNoticeCertification,
            }}
          />
          <div style={{ marginBottom: "12px" }}>
            {statePortalSubmissionsExportEnabled && (
             <Exporter
                submissionPeriodId={submissionPeriodId ?? 0}
                submissionPeriodType={SubmissionPeriodType.customerNoticeCertification}
                params={tableContext.params}
                options={exportOptions}
              />
            )}
          </div>
        </div>
      </TopSectionWrapper>
      {!submissionPeriodId ? (
        <Loader />
      ) : (
        <Card>
          <CustomerNoticeCertificationsTable
            submissionPeriodId={submissionPeriodId}
            tableContext={tableContext}
          />
        </Card>
      )}
    </Page>
  );
};
export default CustomerNoticeCertificationPage;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
`;

const TopSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding-top: 3rem;
  padding-bottom: 2rem;
`;
